import Vue from 'vue'
import 'default-passive-events'
import './router/premit'
import './directive/hasPermi'
import emelent from 'element-ui'

//引入后续自定义 阿里图标
import '@/assets/icons/iconfont.css'
import Print from 'vue-print-nb'
Vue.use(Print)
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import mixin from '@/mixin'
import global from './utils/global' //全局组件,变量js

import echarts from "echarts";
Vue.prototype.$echarts = echarts;

Vue.use(global)
Vue.prototype.bus = new Vue()
Vue.config.productionTip = false

Vue.use(emelent, {
	size: localStorage.getItem('size') || 'medium' // set element-ui default size
})
Vue.mixin(mixin)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
